import { createApp } from 'vue'
import App from './App.vue'
import Switches from 'vue-switches';
import { createPinia } from 'pinia';

import './assets/bootstrap.min.css'
import './assets/leaflet.css';

const pinia = createPinia()
createApp(App).use(pinia).use(Switches).mount('#app')
